import { parseNumber } from "common/utils/numbers";
import Navigate from "common/router/Navigate";
import { useMatch } from "common/router/hooks";

import { ModalStatus } from "client/common/types";
import { urls } from "client/routes";

const OrderPaymentPage = () => {
  const match = useMatch();
  const parsedId = parseNumber(match.params.id, 0);

  return (
    <Navigate
      dest={urls.orders.detail({
        params: { id: parsedId },
        search: { paymentModalIsVisible: ModalStatus.Open },
      })}
    />
  );
};

export default OrderPaymentPage;
